module.exports = __webpack_public_path__ + "img/Oxycodone (OXY).3665b54e.png";